import { COUNTRY_ISO2_MAP } from "./countryIso2Map";

/** Rimuove accenti/diacritici e normalizza a MAIUSCOLO + solo alfanumerico+spazi
 * (stessa normalizzazione usata per generare COUNTRY_ISO2_MAP). */
function normalize(raw: string): string {
  return raw
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9]+/g, " ")
    .trim()
    .toUpperCase();
}

/**
 * Converte una stringa paese grezza (estratta dall'LLM, in qualunque lingua/
 * formato: "Guinée", "GUINEA", "Repubblica Democratica del Congo", "GB", "CN"...)
 * nel codice ISO 3166-1 alpha-2 corrispondente (es. "GN", "CD", "GB", "CN").
 *
 * La dashboard mostra solo alpha-2 (Phase 3). Non hardcoda logica di business
 * — è una tabella di lookup su uno standard ufficiale statico (ISO 3166),
 * generata da pycountry + overlay per le varianti multi-lingua/abbreviazioni
 * osservate nei dati reali Frabemar.
 *
 * Ritorna null se il valore non è riconosciuto — il chiamante deve gestire
 * il fallback (es. mostrare il testo originale troncato) per non rompere mai
 * il layout della dashboard.
 */
export function toCountryIso2(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const key = normalize(raw);
  if (!key) return null;
  return COUNTRY_ISO2_MAP[key] ?? null;
}
